<div class="gemstone">
	<customizer-component-header [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.GEMSTONE.NAME' | translate" [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">

		<div class="customizer-item" (click)="toggleGemstoneOptions()" [ngClass]="{'is-selected': selectedSizeIndex === -1 && !selectedColor}">

			<div class="contentContainer">

				<div class="content">
					<span class="name">{{'CUSTOMIZER.COMPONENTS.GEMSTONE.NOGEMSTONE' | translate}}</span>
				</div>

				@if (noGemstoneImage) {
				<div class="img">
					<img [src]="noGemstoneImage" alt="{{'CUSTOMIZER.COMPONENTS.GEMSTONE.NOGEMSTONE' | translate}}" />
				</div>
				}
			</div>
		</div>

	</customizer-component-header>

	@if (sizes.length) {
	<div class="mt-4">
		<customizer-component-header [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.GEMSTONE.CARAT' | translate" [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
			<customizer-list class="bordered" [noneChoiceTranslation]="noneChoiceTranslation" [selectedIndex]="selectedSizeIndex" (selectedChange)="onSelect($event, selectedColor)" [items]="sizes" [name]="'Description'" [discontinued]="'Discontinued'" [editMode]="state === customizerStateEnum.EDITORDER" [variantOrModelIsNew]="variantOrModelIsNew" [(scrollPosition)]="menu.menuDetails.scrollPosition" [image]="getImage">
			</customizer-list>
		</customizer-component-header>
	</div>
	}

	@if (selectedSizeIndex !== -1 && selectableVariants.length) {
	<div class="mt-4" [ngClass]="{'disabled-color': selectedSizeIndex === -1}">
		<customizer-component-header [overrideTranslateName]="'CUSTOMIZER.COMPONENTS.GEMSTONE.COLOR' | translate" [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
			@if (selectedSizeIndex > -1) {
			<customizer-colors-auto-update [selected]="getSelectedVariant.VariantColor" [showNoneChoiceOption]="showNoneChoiceOption" [selectedColorGroup]="currentColorGroup" [variants]="selectableVariants" [editMode]="state === customizerStateEnum.EDITORDER" [matchableColors]="matchableColors" [useColorGroup]="menu.contentGrouping" (colorMatchChange)="matchColors($event)" (selectedColorGroupChange)="onSelectGroup($event)" (selectedColorChange)="selectedSizeIndex > -1 ? onSelect(selectedSizeIndex, $event) : null" [variantOrModelIsNew]="variantOrModelIsNew" [matchColor]="menu.matchColor">
			</customizer-colors-auto-update>
			}
		</customizer-component-header>
	</div>
	}
</div>